// image-upload.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService {
  private static instance: ImageUploadService;

  private constructor() {}

  uploadImage(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  // private imageFront: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  // imageFront$: Observable<any> = this.imageFront.asObservable();

  // getImageFront(): any { return this.imageFront.getValue(); }
  // setImageFront(data: any): void { this.imageFront.next(data); }

  // private imageDorso: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  // imageDorso$: Observable<any> = this.imageFront.asObservable();

  // getImageDorso(): any { return this.imageDorso.getValue(); }
  // setImageDorso(data: any): void { this.imageDorso.next(data); }
}
